import L from 'leaflet';
import car from './../assets/image/car.png'

const originPin = new L.icon({
    iconUrl: car,
    iconSize: [30, 60],
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
})
const dest1Pin = new L.icon({
    iconUrl: 'https://cdn0.iconfinder.com/data/icons/sports-192/80/location__map__pin__marker__nearby-512.png',
    iconSize: [35, 35],
    iconAnchor: null,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
})


export {
    originPin
};
export {
    dest1Pin
};